import {useCallback} from 'react'
import {useGameStore} from '../GameStoreContext'

export const useShareReplay = () => {
    const shareReplayInReplay = useGameStore((state) => state.gameReplay.replayControls?.onShare)
    const shareReplayInGameEnd = useGameStore((state) => state.gameEnd.endControls?.onClickShareReplay)

    return useCallback(() => {
        if(shareReplayInReplay) shareReplayInReplay()
        else if(shareReplayInGameEnd) shareReplayInGameEnd()
    }, [shareReplayInReplay, shareReplayInGameEnd])
}
